import { useTranslation } from 'react-i18next';

export const useMeTranslation = () => useTranslation('me');
